// Import Redux
import { AnyAction } from 'redux'
// Import Redux Types
import {
  DOWNLOAD_TERMS_DATA,
  SUCCESS_DOWNLOAD_TERMS_DATA,
  ERROR_DOWNLOAD_TERMS_DATA
} from '../types/index'



// State Reducer
const initialState = {
  error: false,
  isLoad: false,
  termsData: []
}



export default ( state = initialState, action:AnyAction ) => {
  switch( action.type ) {
    case DOWNLOAD_TERMS_DATA:
      return {
        ...state,
        error: false,
        isLoad: true
      }
    case SUCCESS_DOWNLOAD_TERMS_DATA:
      return {
        ...state,
        error: false,
        isLoad: false,
        termsData: action.payload
      }
    case ERROR_DOWNLOAD_TERMS_DATA:
      return {
        ...state,
        error: true,
        isLoad: false
      }
    default:
      return {
        ...state
      }
  }
}
